<div *ngIf="!driver.IsArchive" [ngClass]="{'tk-border-blue': isSelected}"
     class="flex bg-white px-4 py-2 grow rounded-lg cursor-pointer">
  <div class="flex">
   <span class="grid place-items-center w-6 h-6 rounded-full text-center text-2xs tk-bg-gray-9-alpha-10">
      <span class="font-semibold tk-c-blue">{{initials}}</span>
    </span>
  </div>

  <div class="ml-3 flex flex-col">
    <div class="font-semibold  text-sm break-normal">{{fullName}}</div>

    <div class="mt-1 flex align-middle">
      <mat-icon fontIcon="call" class="text-sm tk-c-gray-9"></mat-icon>
      <span *ngIf="driver.CN || driver.Pn; else noPhoneTemp" class="text-xs">{{phone}}</span>
      <ng-template #noPhoneTemp>
        <span class="text-xs">{{'labels.none' | translate}}</span>
      </ng-template>
    </div>

    <div class="flex">
      <mat-icon fontIcon="alternate_email" class="text-sm tk-c-gray-9"></mat-icon>
      <span *ngIf="driver.Em; else noEmailTemp" class="text-xs">{{email}}</span>
      <ng-template #noEmailTemp><span class="text-xs">{{'labels.none' | translate}}</span></ng-template>
    </div>

  </div>
</div>

<div *ngIf="driver.IsArchive" [ngClass]="{'tk-border-blue': isSelected}"
     class="flex bg-white px-4 py-2 grow rounded-lg cursor-pointer">
  <div class="flex">
    <span class="grid place-items-center w-6 h-6 rounded-full text-center text-2xs tk-c-gray-9 tk-bg-gray-9-alpha-10">
      <span class="">{{initials}}</span>
    </span>
  </div>

  <div class="ml-3 flex flex-col">
    <div class="font-semibold  text-sm break-normal tk-c-gray-9">{{fullName}}</div>
  </div>
</div>
